export const environment = {
    notificationsRootUrl: 'https://api-notifications.test.epa.ohio.gov',
    clientID: '46f48feb-b842-40d1-bf9a-4f0d88474cb1',
    redirectURI: 'https://notifications.test.epa.ohio.gov/'
};
